import Vue from 'vue';
import Map from '@/components/Map';
import { JSONParser } from '@/utils/JSONParser';
import { MapProps, MapSettings } from '@/components/Map/types';
import { RootElementAttrsHolder } from '@/plugins/RootElementAttrsPlugin';

export function createMapWidget(el: Element) {
    const parser = new JSONParser('createMapWidget');

    const rootAttrs = new RootElementAttrsHolder(el);

    const settings = el.getAttribute('data-settings');

    const props: MapProps = {
        settings: parser.parse<MapSettings>(settings),
    };

    return new Vue({
        el,
        name: 'MapWidget',
        render: (h) => h(Map, { props }),
        rootAttrs,
    });
}
